/*
 * @providesModule TelemetryIntegrations
 */

import type {IntegrationModule} from 'TelemetryTypes';
import {AWSIntegration} from './AWS';

export const integrations: Record<string, IntegrationModule> = {
  aws: AWSIntegration,
};
